// Scroll reveal — adds .is-in to elements with .gg-reveal when they
// enter the viewport. Respects prefers-reduced-motion.

export default function reveal() {
    const els = document.querySelectorAll(".gg-reveal");
    if (!els.length) return;

    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (prefersReducedMotion || !("IntersectionObserver" in window)) {
        els.forEach((el) => el.classList.add("is-in"));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("is-in");
                    observer.unobserve(entry.target);
                }
            });
        },
        // threshold 0: any ratio above it is never reached by blocks many
        // viewports tall (long essays on phones), leaving them hidden.
        { threshold: 0, rootMargin: "0px 0px -40px 0px" }
    );

    els.forEach((el) => observer.observe(el));
}
